import { useSearch } from '@btime/react-contexts'
import React from 'react'

import ServiceOrdersLoader from '../_load/ServiceOrdersLoader'
import ServiceOrdersPublicHistory from './ServiceOrdersPublicHistory'

const PageContent = () => {
  const search = useSearch()

  return (
    <ServiceOrdersLoader search={search}>
      <ServiceOrdersPublicHistory />
    </ServiceOrdersLoader>
  )
}

export default PageContent
